import http from './http';

export default {
  all() {
    return http().get(`/v1/follow_up_sequence_templates`);
  },
  get(id) {
    return http().get(`/v1/follow_up_sequence_templates/${id}`);
  },
  create (data) {
    return http().post(`/v1/follow_up_sequence_templates`, data);
  },
  clone(id) {
    return http().post(`/v1/follow_up_sequence_templates/${id}/clone`);
  },
  update (data) {
    return http().put(`/v1/follow_up_sequence_templates/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v1/follow_up_sequence_templates/${id}`);
  },
}
